import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { customFilter } from "react-bootstrap-table2-filter";
import { useItem, usePagination, useSearch } from "../../../../utils/hooks";
import TableSkeleton from "../../../common/TableSkeleton";
import {
	formatDmenadeSupAccountStatus,
	formatDmenadeSupAccountStatusClass,
	formattedDate,
	isShowPagination,
} from "../../../../utils/utils";
import { CustomPagination } from "../../../common/CustomPagination";
import { useGetDemandeSupCompteQuery } from "../../../../utils/api/user/user.api";
import { DemandeSupAccount, ICompteur } from "../../../../utils/api/user/user.type";
import ChangeStatusDemandeCompteurModal from "./ChangeStatusDemandeCompteurModal";
import { InputFilter } from "../../../common/Input";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
import moment from "moment";
registerLocale("fr", fr);

function ListeDemandesSuppresionCompteTable() {
	const [date, setDate] = useState<Date | null>(null);

	const { search, handlefilter } = useSearch();
	const { search: prenom, handlefilter: handleFilterByPrenom } = useSearch();
	const { search: email, handlefilter: handleFilterByEmail } = useSearch();
	const { search: telephone, handlefilter: handleFilterByPhone } = useSearch();
	const { search: matricule, handlefilter: handlefilterMatricule } = useSearch();
	const { page, setPage, limit, setPerPage } = usePagination(10);

	const { data = { results: [] }, isLoading } = useGetDemandeSupCompteQuery({
		page,
		limit,
		nom: search,
		matricule,
		prenom,
		email,
		telephone,
		date: date !== null ? moment(date).format("YYYY-MM-DD") : null,
	});
	// console.log({ data });

	const { item, getItem } = useItem<ICompteur>();

	const statutFormatter = (cell, row) => {
		return (
			<div className="table-actions-btn-container-img d-flex align-items-center">
				<span
					className={`statut-dossier-item text-capitalize ${formatDmenadeSupAccountStatusClass(cell)}`}
					role="button"
					onClick={() => getItem(row)}
					data-bs-toggle="modal"
				>
					{formatDmenadeSupAccountStatus(cell)}
				</span>
			</div>
		);
	};

	// const actionFormatter = (cell: string, row: ICompteur) => {
	// 	return (
	// 		<>
	// 			<div className="table-actions-btn-container-commandes d-flex gap-3">
	// 				<ButtonViewLink to={`${row?.slug}`} state={row} />
	// 			</div>
	// 		</>
	// 	);
	// };

	const columns = [
		{
			dataField: "user.matricule",
			text: "Matricule",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="matricule" placeholder="Matricule" onChange={handlefilterMatricule} />,
		},
		{
			dataField: "user.prenom",
			text: "Prénom",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="prenom" placeholder="Prénom" onChange={handleFilterByPrenom} />,
		},
		{
			dataField: "user.nom",
			text: "Nom",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="nom" placeholder="Nom" onChange={handlefilter} />,
		},
		{
			dataField: "user.email",
			text: "Email",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="email" placeholder="Email" onChange={handleFilterByEmail} />,
		},
		{
			dataField: "user.telephone",
			text: "Téléphone",
			filter: customFilter(),
			filterRenderer: () => <InputFilter id="tel" placeholder="Téléphone" onChange={handleFilterByPhone} />,
		},
		{
			dataField: "motif",
			text: "Motif",
		},
		{
			dataField: "status",
			text: "Statut",
			formatter: (cell: string, row: DemandeSupAccount) => statutFormatter(cell, row),
		},
		{
			dataField: "created_at",
			text: "Date de demande",
			formatter: (cell: string) => formattedDate(cell),
			filter: customFilter(),
			filterRenderer: () => (
				<div className="date-picker-container">
					<DatePicker
						className="form-control tab-dash-admin-filter-input"
						selected={date}
						onChange={(date: Date) => setDate(date)}
						maxDate={new Date()}
						dateFormat="dd/MM/yyyy"
						placeholderText="Choisir une date"
						isClearable
						locale="fr"
					/>
				</div>
			),
		},
	];

	return (
		<>
			{isLoading && <TableSkeleton headers={columns} />}
			{!isLoading && (
				<>
					<BootstrapTable
						keyField="id"
						data={data?.results}
						columns={columns}
						bordered={true}
						condensed={false}
						responsive={true}
						wrapperClasses="table-responsive admin-table"
						noDataIndication={() => "Aucune donnée trouvée"}
						filter={filterFactory()}
						filterPosition="inline"
					/>
					{isShowPagination(data?.count || 0) && (
						<CustomPagination
							nbPages={data?.count}
							page={page}
							onChange={(page, limit) => {
								setPerPage(limit);
								setPage(page);
							}}
							perPage={limit}
						/>
					)}
				</>
			)}
			<ChangeStatusDemandeCompteurModal modalId="ChangeStatusDemandeCompteur" item={item} />
		</>
	);
}

export default ListeDemandesSuppresionCompteTable;
